import React from 'react';
import { getProducts } from '../data/products';
import { useI18n } from '../i18n';

export default function ProductPage() {
  const { language, t } = useI18n();
  const products = getProducts(language);

  return (
    <main className="catalog-page">
      <section
        className="catalog-hero"
        data-reveal
        style={{
          backgroundImage:
            "linear-gradient(90deg, rgba(13, 15, 16, 0.94), rgba(13, 15, 16, 0.58)), url('/assets/medeo-hero-v2.png')",
        }}
      >
        <div className="section__inner">
          <span className="eyebrow">{t('catalog.eyebrow')}</span>
          <h1>{t('catalog.title')}</h1>
          <p>{t('catalog.text')}</p>
        </div>
      </section>

      <section className="section section--light">
        <div className="section__inner product-list">
          {products.map((product, index) => (
            <article
              className="product-detail"
              data-reveal
              id={product.target}
              key={product.target}
            >
              <div className="product-detail__media">
                <span className="product-detail__number">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <img src={product.image} alt={product.name} loading="lazy" />
              </div>

              <div className="product-detail__content">
                <div className="badge-row">
                  <span>{product.weights}</span>
                  <span>
                    {t('catalog.shelfLife')}: {product.shelfLife}
                  </span>
                </div>
                <h2>{product.name}</h2>
                <p className="product-detail__lead">{product.accent}</p>
                <p>{product.description}</p>
                <div className="composition">
                  <strong>{t('catalog.composition')}</strong>
                  <p>{product.composition}</p>
                </div>

                {product.nutrition && (
                  <div className="nutrition">
                    <strong>{t('catalog.nutrition')}</strong>
                    <span>
                      {t('catalog.proteins')}: {product.nutrition.proteins}
                    </span>
                    <span>
                      {t('catalog.carbs')}: {product.nutrition.carbs}
                    </span>
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="quality-strip" data-reveal>
        <div className="section__inner quality-strip__inner">
          <img src="/assets/gost.png" alt="ГОСТ" loading="lazy" />
          <div>
            <span className="eyebrow">{t('catalog.qualityEyebrow')}</span>
            <h2>{t('catalog.qualityTitle')}</h2>
          </div>
          <a className="button button--primary" href="/#documents">
            {t('nav.documents')}
          </a>
        </div>
      </section>
    </main>
  );
}
